module.exports = __webpack_public_path__ + "img/goods01.50b9e4f3.png";